import { render, staticRenderFns } from "./VDealDecision.vue?vue&type=template&id=e809b52a"
import script from "./VDealDecision.vue?vue&type=script&lang=js"
export * from "./VDealDecision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports